import React from "react";
import {
  Route,
  Routes,
  BrowserRouter,
  Navigate,
  useLocation,
} from "react-router-dom";

import Index from "./Pages/Index";
import Menu from "./Pages/Menu";
import Checklist from "./Pages/Checklist";
import Servicos from "./Pages/Servicos";
import Pastas from "./Pages/Pastas";
import CadCargo from "./Pages/CadCargo";
import CadOperador from "./Pages/CadOperador";
import CadCliente from "./Pages/CadCliente";
import VincularUsuarioProcesso from "./Pages/CadUsuarioProcesso";
import Planejamento from "./Pages/Planejamento";
import CadastroPlanejamento from "./Pages/CadPlanejamento";
import Patrimonio from "./Pages/Patrimonio";
import CadPatrimonio from "./Pages/CadPatrimonio";
import CadastroOperadorExterno from "./Pages/CadOperadorExterno";
import AprovarOperadoresExternos from "./Pages/AprovOperadorExterno";
import CadUploadEstrutura from './Pages/CadUploadEstrutura';
import VincularProcessoUsuarios from './Pages/CadProcessoUsuario';

import { useAuthContext } from "./context/authContext";

const routeNames = {
  index: "/",
  menu: "/Menu",
  upload: "/Upload",
  checklist: "/Checklist",
  Servicos: "/Servicos/:IDCliente",
  Pastas: "/Pastas/:IDCliente/:IDProcesso/:IDPastaPai",
  CadCargo: "/CadCargo",
  CadOperador: "/CadOperador",
  CadCliente: "/CadCliente",
  UsuarioProcesso: "/CadOperadorProcesso",
  Planejamento: "/Planejamento/:IDCliente/:IDProcesso",
  CadPlanejamento: "/CadastroPlanejamento",
  Patrimonio: "/AuditoriaPatrimonial/:IDCliente",
  CadPatrimonio: "/CadPatrimonio/:IDCliente",
  CadExterno: "/cadexterno/:idCliente",
  AprovarOperadoresExternos: "/aprovexterno",
  CadUploadEstrutura: "/UploadEstrutura/:IDProcesso/:IDDiretorioPai/:NomeBucketAws",
  VincularProcessoUsuarios: "/CadProcessoOperador",
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, authReady } = useAuthContext();
  const location = useLocation();

  if (!authReady) return <div>Carregando...</div>;

  if (!isAuthenticated && location.pathname !== "/") {
    return <Navigate to="/" replace />;
  }

  return children;
};

const Rotas = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rota pública: Login */}
        <Route path={routeNames.index} element={<Index />} />
        <Route path={routeNames.CadExterno} element={<CadastroOperadorExterno />} />

        {/* Rotas protegidas */}
        <Route path={routeNames.menu} element={<ProtectedRoute> <Menu /> </ProtectedRoute>} />
        <Route path={routeNames.checklist} element={<ProtectedRoute> <Checklist /></ProtectedRoute>} />
        <Route path={routeNames.Servicos} element={<ProtectedRoute> <Servicos /></ProtectedRoute>} />
        <Route path={routeNames.Pastas} element={<ProtectedRoute> <Pastas /> </ProtectedRoute>} />
        <Route path={routeNames.CadCargo} element={<ProtectedRoute> <CadCargo /> </ProtectedRoute>} />
        <Route path={routeNames.CadOperador} element={<ProtectedRoute> <CadOperador /> </ProtectedRoute>} />
        <Route path={routeNames.CadCliente} element={<ProtectedRoute> <CadCliente /> </ProtectedRoute>} />
        <Route path={routeNames.CadPlanejamento} element={<ProtectedRoute> <CadastroPlanejamento /> </ProtectedRoute>} />
        <Route path={routeNames.UsuarioProcesso} element={<ProtectedRoute> <VincularUsuarioProcesso /> </ProtectedRoute>} />
        <Route path={routeNames.Planejamento} element={<ProtectedRoute> <Planejamento /> </ProtectedRoute>} />
        <Route path={routeNames.Patrimonio} element={<ProtectedRoute> <Patrimonio /> </ProtectedRoute>} />
        <Route path={routeNames.CadPatrimonio} element={<ProtectedRoute> <CadPatrimonio /> </ProtectedRoute>} />
        <Route path={routeNames.AprovarOperadoresExternos} element={<ProtectedRoute> <AprovarOperadoresExternos /> </ProtectedRoute>} />
        <Route path={routeNames.CadUploadEstrutura} element={<ProtectedRoute> <CadUploadEstrutura /> </ProtectedRoute>} />
        <Route path={routeNames.VincularProcessoUsuarios} element={<ProtectedRoute> <VincularProcessoUsuarios /> </ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
};

export default Rotas;
